// eslint-disable-next-line no-unused-vars
import React, { useMemo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatCurreny } from '../utils/services';
import {
  getWalletSummary as walletSummary,
  getWalletTransactions as walletTransactions
} from '../burger-king-lib/redux/wallet/actions';
import { LocalStorage } from '../burger-king-lib/utils/storage.web';
import { LocalSessionKey } from '../burger-king-lib/constants/app-constants';

export function useWalletSummaryDispatch() {
  const dispatch = useDispatch();

  const getWalletSummary = () => {
    const userId = LocalStorage.get(LocalSessionKey.USER_ID);
    if (!userId) return;
    const params = new URLSearchParams({
      userId
    });
    dispatch(walletSummary(params.toString()));
  };

  useEffect(() => {
    getWalletSummary();
  }, []);
}

export function useWalletSummarySelector() {
  const walletSummaryData = useSelector(
    state => state.wallet?.walletData || {}
  );

  const walletAmount = useMemo(() => {
    const amount = walletSummaryData?.availableBalance;
    const currency = walletSummaryData?.currency;

    return formatCurreny(amount, currency);
  }, [walletSummaryData?.availableBalance, walletSummaryData?.currency]);

  return {
    walletAmount,
    recentTransactions: walletSummaryData?.recentTransactions || []
  };
}

const WALLET_TRANSACTION_TABS_LIST = ['ALL', 'DEBIT', 'CREDIT'];

export function useWalletTransactions() {
  const [filters, setFilters] = useState(() => ({
    page: 1,
    pageSize: 20,
    type: 'ALL'
  }));
  const dispatch = useDispatch();

  const walletTransactionData = useSelector(
    state => state?.wallet?.walletTransactionData
  );

  const handleTabChange = (tab = '') => {
    const filterTab = (tab || '').toUpperCase();
    if (!WALLET_TRANSACTION_TABS_LIST.includes(filterTab)) return;

    setFilters(prev => ({ ...prev, type: tab }));
  };

  const getWalletTransactions = async () => {
    const userId = LocalStorage.get(LocalSessionKey.USER_ID);
    if (!userId) return;

    const params = new URLSearchParams({ ...filters, userId });

    await dispatch(walletTransactions(params.toString()));
  };

  useEffect(() => {
    getWalletTransactions(filters);
  }, [filters]);

  return {
    filters,
    handleTabChange,
    transactions: walletTransactionData?.transactions || []
  };
}

// export const withWallet = Component => {
//   return function MyComponent(props) {
//     const { recentTransactions, walletAmount } = useWallet();

//     return (
//       <Component
//         // eslint-disable-next-line react/jsx-props-no-spreading
//         {...props}
//         // getWalletSummary={getWalletSummary}
//         walletAmount={walletAmount}
//         recentTransactions={recentTransactions}
//       />
//     );
//   };
// };
